import { motion } from "framer-motion";
import React, { useState } from "react";
import { FaCloudUploadAlt, MdDelete } from "../../assets/icons";
import { buttonClick, imageWhileHover } from "../../utils/animations";

import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { storage } from "../../config/firebase.config";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";

const ImageUploader = ({ setImageDownloadUrl, imageDownloadUrl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [{ alertState, alertType }, dispatch] = useStateValue();

  const deleteImageFromFirebase = (imageURL) => {
    setIsLoading(true);
    const deletRef = ref(storage, imageURL);
    deleteObject(deletRef)
      .then(() => {
        setImageDownloadUrl(null);
        setIsLoading(false);
        dispatch({
          type: actionType.SET_ALERT_TYPE,
          alertType: "successDelete",
        });
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

        setTimeout(() => {
          dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
          dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
        }, 3000);
      })
      .catch((er) => {
        console.log(er);
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "danger" });
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

        setTimeout(() => {
          dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
          dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
        }, 3000);
      });
  };

  const uploadImage = (e) => {
    setIsLoading(true);

    const imageFile = e.target.files[0];
    const storageRef = ref(storage, `Pictures/${Date.now()}_${imageFile.name}`);

    const uploadTask = uploadBytesResumable(storageRef, imageFile);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        setProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      },
      (er) => {
        console.log(er);
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "danger" });
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

        setTimeout(() => {
          dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
          dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
        }, 3000);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadUrl) => {
          setImageDownloadUrl(downloadUrl);
          setIsLoading(false);
          setProgress(0);
          dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "info" });
          dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

          setTimeout(() => {
            dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
            dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
          }, 3000);
        });
      }
    );
  };
  return (
    <div className=" w-full bg-card backdrop-blur-md h-300 rounded-md border-2 border-dotted border-gray-300 cursor-pointer">
      {isLoading && (
        <div className="w-full h-full flex flex-col items-center justify-evenly px-24">
          <Spinner />
          {Math.round(progress > 0) && (
            <div className=" w-full flex flex-col items-center justify-center gap-2">
              <div className="flex justify-between w-full">
                <span className="text-base font-medium text-textColor">
                  Progress
                </span>
                <span className="text-sm font-medium text-textColor">
                  {Math.round(progress) > 0 && (
                    <>{`${Math.round(progress)}%`}</>
                  )}
                </span>
              </div>

              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out"
                  style={{
                    width: `${Math.round(progress)}%`,
                  }}
                ></div>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && (
        <>
          {!imageDownloadUrl ? (
            <>
              <label>
                <div className=" flex flex-col items-center justify-center h-full w-full cursor-pointer">
                  <div className="flex flex-col justify-center items-center cursor-pointer">
                    <p className="font-bold text-4xl">
                      <FaCloudUploadAlt className="-rotate-0" />
                    </p>
                    <p className="text-lg text-textColor">
                      Click to upload an image
                    </p>
                  </div>
                </div>
                <input
                  type="file"
                  name="upload-image"
                  accept="image/*"
                  onChange={uploadImage}
                  className=" w-0 h-0"
                />
              </label>
            </>
          ) : (
            <>
              <div className="relative w-full h-full overflow-hidden rounded-md">
                <motion.img
                  {...imageWhileHover}
                  src={imageDownloadUrl}
                  className=" w-full h-full object-cover"
                />

                <motion.button
                  {...buttonClick}
                  type="button"
                  className="absolute top-3 right-3 p-3 rounded-full bg-red-500 text-xl cursor-pointer outline-none hover:shadow-md duration-500 transition-all ease-in-out"
                  onClick={() => deleteImageFromFirebase(imageDownloadUrl)}
                >
                  <MdDelete className="-rotate-0" />
                </motion.button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export const Spinner = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center">
      <div className="w-10 h-10 bg-blue-600 animate-ping rounded-full flex items-center justify-center relative">
        <div className="absolute inset-0 rounded-full bg-blue-600 blur-xl"></div>
      </div>
    </div>
  );
};

export default ImageUploader;
